export const SUPPORTED_LOCALES = ['en', 'es', 'fr']

export const normalizeLocale = lng => {
  if (!lng) return undefined

  const normalized = lng.toLowerCase()
  return SUPPORTED_LOCALES.includes(normalized) ? normalized : undefined
}

export const changeLanguage = (i18n, lng) => {
  const normalized = normalizeLocale(lng)
  if (normalized) i18n.changeLanguage(normalized)
}
